module.exports = __webpack_public_path__ + "img/email_icon.919d6526.png";